import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
} from '@angular/common/http';
import { finalize, Observable } from 'rxjs';
import { LoaderService } from '@core/services/loader/loader.service';

@Injectable()
export class LoaderInterceptor implements HttpInterceptor {
  private totalRequest: number = 0;
  private completedRequest: number = 0;

  constructor(private loaderService: LoaderService) {}

  intercept(
    request: HttpRequest<unknown>,
    next: HttpHandler
  ): Observable<HttpEvent<unknown>> {
    if (request.url.indexOf('api') >= 1) {
      this.loaderService.show();
      this.totalRequest++;

      return next.handle(request).pipe(
        finalize(() => {
          this.completedRequest++;
          if (this.totalRequest === this.completedRequest) {
            this.loaderService.hide();
          }
        })
      );
    }

    return next.handle(request);
  }
}
